import classnames from 'classnames';
import React from 'react';
import { forwardRef } from 'react';

import Button, { themes } from '../UI/Button/Button';
import Icon from '../UI/Icon/Icon';
import Link from '../UI/Link/Link';
import WpImage, { imgSizes } from '../UI/WpImage/WpImage';
import * as styles from './LocationCard.module.scss';

const LocationCard = forwardRef(
  (
    {
      counter,
      title,
      image,
      address,
      telephone,
      path,
      distance,
      isCard = false,
      isPrimary = false,
    },
    ref
  ) => {
    const className = classnames(styles.container, {
      [ styles.isPrimary ]: isPrimary,
      [ styles.isCard ]: isCard
    });

    return (
      <article className={className} ref={ref}>
        {image && (
          <WpImage
            className={styles.image}
            {...image}
            size={isPrimary ? imgSizes.MEDIUM : imgSizes.THUMBNAIL}
            width={isPrimary || isCard ? null : 110}
            height={isPrimary || isCard ? null : 115}
          />
        )}
        <div className={styles.body}>
          {distance && (
            <p className={styles.distance}>
              <Icon name="map-pin" /> {Math.round(distance)} miles
            </p>
          )}

          <h3 className={styles.title}>
            {path ? (
              <Link to={path}>
                {counter ? `${counter}.` : ``} {title}
              </Link>
            ) : (
              `${counter ? `${counter}.` : ``} ${title}`
            )}
          </h3>

          {address && <p className={styles.address}>{address}</p>}

          {telephone && (
            <p>
              <a
                className={styles.tel}
                href={`tel:+${telephone.replace(/ /g, '')}`}
              >
                <Icon name="phone" /> {telephone}
              </a>
            </p>
          )}

          {isPrimary && path && (
            <Button to={path} theme={themes.LINK}>
              View details
            </Button>
          )}
        </div>
      </article>
    );
  }
);

export default LocationCard;
